var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.styles,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.back($event)}}},[_vm._t("default",[_c('i',{staticClass:"fa fa-chevron-circle-left m-r-5"}),_vm._v(" "+_vm._s(_vm.$t('back'))+"\n    ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9dc06718","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/BackButton.vue
// module id = null
// module chunks = 